// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3YQHc","label":"Category_label__BDCKS","content":"Category_content__39ZN6","header":"Category_header__1p4wv","location":"Category_location__1oETc"};